import React, { ReactNode, useMemo, useState } from "react";
import styled from "styled-components";

import { parseUnitObjective } from "@examspark/api";
import { Grid } from "@examspark/common-ui";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";
import {
  getObjectiveCategory,
  ObjectiveIndicator,
} from "@examspark/customer/tcmpc";
import { ObjectivesItem, Unit } from "@examspark/types";

import ObjectiveBadge from "../../../common/ObjectiveBadge";
import ObjectiveDetailModal from "../../../ObjectiveDetailModal";

const StyledStandards = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${colorFromTheme("surface5")};
  padding: 1rem 0;
  gap: 1rem;

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`;

const StyledStandardsLabel = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 1.1rem;
  align-items: center;
`;
const StyledStandardsList = styled.div``;

const YagUnitStandards = ({
  objectives,
  unit,
  label,
  showIndicator,
}: {
  objectives: ObjectivesItem[] | undefined;
  unit: Unit | null | undefined;
  label: ReactNode;
  showIndicator: boolean;
}) => {
  const [modalObjectivesIndex, setModalObjectivesIndex] = useState<number>();

  const parsedStandards = useMemo(
    () => objectives?.map((o) => parseUnitObjective(o)),
    [objectives],
  );

  if (!objectives?.length) return null;

  return (
    <>
      <ObjectiveDetailModal
        objectives={parsedStandards}
        unit={unit}
        showIndex={modalObjectivesIndex}
        onShowIndexChange={setModalObjectivesIndex}
      />
      <StyledStandards>
        <StyledStandardsLabel>
          <div>{label}</div>
        </StyledStandardsLabel>
        <StyledStandardsList>
          <Grid size="10rem" gap="0.3rem">
            {objectives?.map((s, index) => (
              <ObjectiveBadge
                key={s.id}
                objectivesItem={s}
                showTooltip
                trailingContent={
                  showIndicator && (
                    <ObjectiveIndicator
                      value={getObjectiveCategory(s.objective)}
                    />
                  )
                }
                onClick={() => {
                  if (!s.objective) return;
                  setModalObjectivesIndex(index);
                }}
              />
            ))}
          </Grid>
        </StyledStandardsList>
      </StyledStandards>
    </>
  );
};

export default YagUnitStandards;
